import { Label, Stack, useTheme } from '@fluentui/react';
import * as React from 'react';
import { IInvoice } from '../../../Models/Invoice/IInvoice';

interface IInvoiceSumaryViewProps {
    invoice?: IInvoice;
}


export const InvoiceSumaryView: React.FunctionComponent<IInvoiceSumaryViewProps> = (props) => {

    const theme = useTheme();
    const uhradit = ((props.invoice?.totalWidthVat ? props.invoice.totalWidthVat : 0) - (props.invoice?.totalPaid ? props.invoice?.totalPaid : 0));
    return (<Stack>
        <table>
            <tr>
                <td><Label>Celkem</Label></td>
                <td><Label>Zaplaceno</Label></td>
                <td><Label>Uhradit</Label></td>
            </tr>
            <tr>
                <td>{props.invoice?.totalWidthVat.toFixed(2)} Kč</td>
                <td>{props.invoice?.totalPaid.toFixed(2)} Kč</td>
                <td><Label style={{ color: (uhradit > 0 ? theme.semanticColors.errorText : theme.semanticColors.successText), fontSize: 20 }}>{uhradit.toFixed(2)} Kč</Label></td>
            </tr>
        </table>

    </Stack>)
}
